import type { Wrex } from '@lumapps/wrex/types';

import { PLAY_VIDEO } from '../constants';
import type { PlayVideoElement } from '../types';

/** Create a play video element */
export const createPlayVideo = (attributes: Wrex.ElementAttributes<PlayVideoElement>): PlayVideoElement => {
    return { type: PLAY_VIDEO, ...attributes, children: [{ text: '' }] };
};
